export const skills = {
  frontend: [
    {
      name: "ReactJs",
      percent: "70",
      logo: "react",
    },
    {
      name: "HTML5",
      percent: "80",
      logo: "htmlLogo",
    },
    {
      name: "CSS3",
      percent: "80",
      logo: "css",
    },
    {
      name: "Typescript",
      percent: "70",
      logo: "ts",
    },
    {
      name: "Javascript",
      percent: "75",
      logo: "js",
    },
    {
      name: "Tailwind CSS",
      percent: "75",
      logo: "tailwind",
    },
  ],
  backend: [
    {
      name: "NodeJs",
      percent: "70",
      logo: "nodejs",
    },
    {
      name: "ExpressJs",
      percent: "70",
      logo: "expressjs",
    },
    {
      name: "MongoDb",
      percent: "75",
      logo: "mongo",
    },
    {
      name: "Zustand",
      percent: "70",
      logo: "othSkill",
    },
    {
      name: "Typescript",
      percent: "70",
      logo: "ts",
    },
    {
      name: "Rest API",
      percent: "75",
      logo: "othSkill",
    },
    // {
    //     name: "User Authentication",
    //     percent: "70",
    //     logo: "othSkill"
    // }
  ],
  toolsAndPlatforms: [
    {
      name: "Git",
      logo: "othSkill",
    },
    {
      name: "Github",
      logo: "othSkill",
    },
    {
      name: "CI/CD Pipelines",
      logo: "othSkill",
    },
    {
      name: "Postman",
      logo: "othSkill",
    },

    {
      name: "Figma",
      logo: "othSkill",
    },
  ],
  other: [
    {
      name: "DSA",
      percent: "80",
      logo: "othSkill",
    },
    {
      name: "Problem Solving",
      percent: "90",
      logo: "othSkill",
    },
    {
      name: "Adaptability",
      percent: "80",
      logo: "othSkill",
    },
    {
      name: "Punctuality",
      percent: "90",
      logo: "othSkill",
    },
    {
      name: "Communication",
      percent: "70",
      logo: "othSkill",
    },
  ],
};

export const experiences = [
  {
    company: "IT Idol Technologies",
    logo: "itidol",
    role: "Associate Software Developer",
    url: "https://in.linkedin.com/company/it-idol-technologies",
    duration: "Jan 2026 - Present",
    desc: [
      "As an intern learning to collaboration in a team, contribute on real world projects and communication with clients.",
    ],
    skills: [
      {
        logo: "react",
        name: "ReactJs",
      },
      {
        logo: "nodejs",
        name: "NodeJs",
      },
      {
        logo: "expressjs",
        name: "ExpressJs",
      },
      {
        logo: "mongo",
        name: "MongoDb",
      },
      {
        logo: "othSkill",
        name: "Communication",
      },
    ],
  },
  {
    company: "AccioJob",
    logo: "accio",
    role: "Software Development Trainee",
    url: "https://www.linkedin.com/school/acciojob/ ",
    duration: "Oct 2024 - May 2025",
    desc: [
      "Completed a specialized training in Data Structures and Algorithms (Java) and Software Development with AccioJob, in partnership with Parul University, focusing on building problem solving and industry-ready skills.",
    ],
    skills: [
      {
        logo: "java",
        name: "Java",
      },
      {
        logo: "othSkill",
        name: "DSA",
      },
      {
        logo: "othSkill",
        name: "Problem Solving",
      },
      {
        logo: "othSkill",
        name: "Software Development",
      },
    ],
  },
  {
    company: "Mr Loggage",
    logo: "mrLgg",
    role: "Full Stack Web Developer",
    url: "https://www.linkedin.com/company/mrloggage/",
    duration: "Jun 2024 - Aug 2024",
    desc: [
      "On-site Developed a Dynamic and User-friendly project on MERN Stack technology by collaboration with Mr Loggage team.",
    ],
    skills: [
      {
        logo: "react",
        name: "ReactJs",
      },
      {
        logo: "nodejs",
        name: "NodeJs",
      },
      {
        logo: "expressjs",
        name: "ExpressJs",
      },
      {
        logo: "mongo",
        name: "MongoDb",
      },
    ],
  },
  {
    company: "Navpad Infotech",
    logo: "nvpd",
    role: "Full Stack Developer",
    url: "http://new.navpadinfotech.com/",
    duration: "Jan 2024 - May 2024",
    desc: [
      "Built a Real World project 'Student Leave Management System' using the latest stack - MERN Stack, which is assigned by Navpad Infotech as a project of my Academic journey.",
    ],
    skills: [
      {
        logo: "react",
        name: "ReactJs",
      },
      {
        logo: "nodejs",
        name: "NodeJs",
      },
      {
        logo: "expressjs",
        name: "ExpressJs",
      },
      {
        logo: "mongo",
        name: "MongoDb",
      },
    ],
  },
];

export const projects = [
  {
    title: "EffiQ - Queue Avoidance System",
    logo: "efqProj",
    github: "https://github.com/UshankWagh/UnQue",
    techs: "Socket.io, Real-time App, MERN Stack, REST APIs",
    desc: "Developed a Real Time online queueing system that reduces wait times for customers at shop and streamline large queue handling for shopkeepers.",
  },
  {
    title: "Student Leave Management System",
    logo: "slmsProj",
    github: "https://github.com/VishankWagh/SLMS",
    techs: "ReactJs, NodeJs, ExpressJs, MongoDb",
    desc: "Built an online platform to tackle a real world problem by managing student’s leaves on the SLMS system, which was assigned to me as an intern at Navpad Infotech.",
  },
  {
    title: "Quik Buy",
    logo: "qbProj",
    github: "https://github.com/VishankWagh/Online-Local-Store",
    live: "https://quik-buy.vercel.app",
    techs: "ReactJs, NodeJs, ExpressJs, MongoDb",
    desc: "Streamline your local shopping experience with Quik Buy—an MERN stack online store connecting you to nearby retail shops for effortless product ordering and doorstep delivery.",
  },
  {
    title: "Personal Portfolio Website",
    logo: "pfloProj",
    github: "https://github.com/VishankWagh/Vishank-Portfolio",
    live: "https://portfolio-vishank-wagh.vercel.app",
    techs: "ReactJs, HTML 5, CSS 3, Javascript",
    desc: "Checkout my personal portfolio website to have a glimpse of my skillsets, experiences and how well i can contribute them in building something new and innovative.",
  },
  {
    title: "HabiTrack — Habit & Productivity Tracker",
    logo: "habiProj",
    // github: "https://github.com/VishankWagh/Vishank-Portfolio",
    techs: "ReactJs, Typescript, Tailwind CSS",
    desc: "Built a solo TypeScript learning project solving the problem of losing track of daily habits by providing a visual productivity system — featuring habit creation, daily streak tracking with automatic streak-break detection on missed days, and a best-habit spotlight based on longest active streak.",
  },
  {
    title: "Order Desk",
    logo: "orddkProj",
    techs: "ReactJs, NodeJs, ExpressJs, MongoDb",
    desc: "Order desk is a portal for customers to order for food in restaurent by just few clicks and get the product delivered to their table in a quick and simple way.",
  },
  {
    title: "Pomodoro App Clone",
    logo: "pmdrProj",
    techs: "ReactJs, HTML 5, CSS 3",
    desc: "Boost your productivity with Pomodor—an efficient React app that helps you work in focused intervals, setting timers like 25 minutes, punctuated by customizable short breaks of your choice.",
  },
  // {
  //     title: "Futuristic Drones Website",
  //     logo: "drnProj",
  //     live: "https://vsw-designs-drones-technology.w3spaces.com/",
  //     techs: "HTML 5, CSS 3",
  //     desc: "Explore the world of drones through this classic portfolio website, showcasing the cutting-edge features of the company's drone technology."
  // },
  // {
  //     title: "Future Technology",
  //     logo: "tchProj",
  //     techs: "HTML 5, CSS 3",
  //     desc: "Dive into the future with 'Future Technologies,' a captivating blog featuring a professional and visually appealing GUI that also showcases my designing ability. Explore the possibilities of tomorrow today."
  // }
];

export const certificates = [
  {
    title: "Udemy: The Web Developer Bootcamp 2024",
    imgUrl: "crtiudmy1",
  },
  {
    title: "Udemy: The Complete 2023 Web Development Bootcamp",
    imgUrl: "crtiudmy2",
  },
  {
    title: "Scaler: SOLID Principles every developer must know",
    imgUrl: "crtisolid",
  },
  {
    title: "Sololearn: Web Development Fundamentals",
    imgUrl: "crtiwdev",
  },
  {
    title: "Listening Competition FunFest 2022-23",
    imgUrl: "crtilstn",
  },
];
